import { getAxiosInstance } from "../ApiConfig";

async function fetchLastchatHistory(companyId) {
    try {
        const response = await getAxiosInstance().get(`/findLatestChatHistoryByUserAndCompanyCode/${companyId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchSuggestedQuestions(hasOpenRecord) {
    try {
        const response = await getAxiosInstance().get(`/getSuggestions/${hasOpenRecord}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function Userchatsubmit(payload) {
    try {
        const response = await getAxiosInstance().post(`/searchCrmData`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function genieChatDelte(id) {
    try {
        const response = await getAxiosInstance().delete(`/deleteChatHistory/${id}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function genieChatClear(code) {
    try {
        const response = await getAxiosInstance().delete(`/clearAllChatHistory/${code}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    fetchSuggestedQuestions,
    fetchLastchatHistory,
    Userchatsubmit,
    genieChatDelte,
    genieChatClear,
}